import { Type } from 'class-transformer';
import { PublishInfoRawDto } from './publish-info-raw-dto';
import { ContactDetailPublishInfoRawDto } from './contact-detail-publish-info-raw-dto';

export class ContactPublishInfoRawDto {
  contactId: number;
  sequence: number;
  contactType: string;

  @Type(() => PublishInfoRawDto)
  name: PublishInfoRawDto;

  @Type(() => PublishInfoRawDto)
  photo: PublishInfoRawDto;

  @Type(() => PublishInfoRawDto)
  address: PublishInfoRawDto;

  @Type(() => ContactDetailPublishInfoRawDto)
  contactPhones: Array<ContactDetailPublishInfoRawDto>;

  @Type(() => ContactDetailPublishInfoRawDto)
  contactEmails: Array<ContactDetailPublishInfoRawDto>;

  //Transient
  photoUrl: string = 'assets/images/avatar_question_round.png';
}
